export const data = {
  whoWeAre: '*KING EDWARDS ACADEMY GROUP OF SCHOOLS (KEA),* located just outside Masvingo, opened its gates in ' +
    'January 2025 and provides quality education from Form 1 through Form 6. As a Christian-oriented, private ' +
    'high school, KING EDWARDS ACADEMY offers both boarding and day school options with modern facilities. ' +
    'The college is registered with the Ministry of Primary and Secondary Education and offers both the ' +
    'Cambridge International and the ZIMSEC curricula, preparing learners for global success while maintaining ' +
    'pride in our national heritage. Enrolment is open, and you can apply online to take advantage of ' +
    'attractive discounts on fees. KEA focuses on producing students who are competent in modern global ' +
    'markets, supported by strong local and international affiliations, particularly with top universities in ' +
    'the United Kingdom.'
}

export const whyChooseUs = [
  {
    id: 1,
    title: 'Both Cambridge and ZIMSEC Curricula',
    desc: 'Families choose the pathway that suits their child. Both are taught to the same high standard, ' +
      'from Form 1 to Form 6.'
  },
  {
    id: 2,
    title: 'Highly Qualified Teaching and Non-Teaching Staff',
    desc: 'Experienced, subject-specialist teachers supported by a professional non-teaching team who look ' +
      'after every learner in our care.'
  },
  {
    id: 3,
    title: 'Flexible Payment Plans',
    desc: 'School fees can be settled in three manageable installments per term, making a quality education ' +
      'easier to plan for.'
  },
  {
    id: 4,
    title: 'Strong Emphasis on Practical Subjects',
    desc: 'Well equipped laboratories, computer suites and workshops mean learners apply what they are ' +
      'taught, not just memorise it.'
  },
  {
    id: 5,
    title: 'Boarding and Day School Options',
    desc: 'Modern, secure boarding facilities alongside day school places for families closer to Masvingo.'
  },
  {
    id: 6,
    title: 'Christian Values and Ethical Foundation',
    desc: 'A caring, disciplined environment where character is developed alongside academic ability.'
  },
  {
    id: 7,
    title: 'International University Pathways',
    desc: 'Strong local and international affiliations, particularly with top universities in the United ' +
      'Kingdom, open doors for our school leavers.'
  }
]
